import React from "react";
import { SimpleSelectableButton } from "./simple.selectable.button";
import { SelectableButtonBarProps } from "@me8eon/components";


export function SimpleSelectableButtonBar({ options, selectedOps, rootId }: SelectableButtonBarProps) {
    const SelectableButton = SimpleSelectableButton;
    return (
        <div style={{ display: "flex", flexWrap: "wrap", gap: "2px" }}>
            {options.map(option => (
                <SelectableButton
                    key={option}
                    rootId={rootId}
                    selectedOps={selectedOps}
                    text={option}
                    rawText={true}
                />
            ))}
        </div>
    );
}